export default __webpack_public_path__ + "static/media/MatchRiteCare_logo_color_gradient_102220.172f5686.jpg";